import { useNavigate } from "react-router-dom"
import { Box, Container, Grid, Typography } from "@mui/material"

import QuestionAnswer from "../../../components/QuestionAnswer"
import ShowMoreButton from "../../../components/ShowMoreButton"
import { useFAQPreview } from "../../../hooks/useFAQs"

const FAQs = () => {
    const navigate = useNavigate()
    const { faqs, totalFaqs, loading } = useFAQPreview(12)

    return (
        <Box component="section" sx={{ py: 5 }} id="faqs">
            <Container maxWidth="lg">
                <Typography variant="h4" fontWeight="bold" textAlign="center" paddingBottom={5}>
                    Frequently Asked Questions
                </Typography>

                {!loading && totalFaqs > 0 && (
                    <Typography variant="body2" textAlign="right" mb={2}>
                        Showing {faqs.length} of {totalFaqs} questions
                    </Typography>
                )}

                <Grid container spacing={2}>
                    {faqs.map((faq) => (
                        <QuestionAnswer {...faq} key={faq._id.toString()} />
                    ))}
                </Grid>

                <ShowMoreButton
                    label="View more"
                    align="right"
                    onClick={() => navigate("/faqs")}
                />
            </Container>
        </Box>
    )
}

export default FAQs
